import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./dev.css";
import "../node_modules/aos/dist/aos.css";
import { Provider } from "react-redux";
import store, { persistor } from "store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
